export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5644.70cce480.jpg";